export const ListHeight = (list, itemHeight = 50, delayPerItem = 200) => ({
    maxHeight: list && list.length > 0 ? list.length * itemHeight : 0,
    transition: `max-height ${(list && list.length) ? list.length * delayPerItem : 500}ms`
});
